import styled from 'styled-components';

import { Box } from 'components/Box';
import { cssBreakpoints, transition } from 'theme';

export const PageHeaderNavLinks = styled(Box)<{ $menuOpen?: boolean }>`
  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    visibility: ${(props) => (props.$menuOpen ? 'visible' : 'hidden')};
    position: fixed;
    bottom: 100%;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    max-width: 100%;
    overflow-y: scroll;
    background: white;

    box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
    transition:
      transform ${transition},
      visibility ${transition};
    will-change: transform;
    ${(props) =>
      props.$menuOpen
        ? `
      transform: translateY(100%);
    `
        : `
      transform: translateY(-6px);
    `}
  }
`;
